/*jshint bitwise: false*/


PegasusTemplate.BlockMutatorBaseMixin = Ember.Mixin.create({
  attributeBindings: ['payload.dataIsDisplayed:data-is-displayed'],
  mutateForIn: function( element, row, column ){
    var payload, model;

    if( !element ){ return; }

    payload = this.get('payload');
    PegasusTemplate.Helpers.scrapeAttributes( element, payload );
    PegasusTemplate.Helpers.scrapeClassNames( element, payload );
    model = this.newModel( $( element ).get(0), payload );
    payload.setProperties(model);

    this.set('sourceElement', $( element ).get(0) );

    if ( row ) {
      this.set('row', row);
    }
    if ( column ) {
      this.set('column', column);
    }
    if ( row ) {
      row.get('blocks').addObject(this);
    }
  },

  dataVrStructurePaddingBottomBinding: 'row.bottomPaddingCell.dataVrStructurePaddingBottom',
  dataVrStructurePaddingTopBinding: 'row.topPaddingCell.dataVrStructurePaddingTop',

  toolbarProperties: function(){
    var props = Object.keys( Em.meta( this ).watching );
    var self = this;
    var reg = /^payload./;
    var base = {
      dataVrStructurePaddingTop: this.get('dataVrStructurePaddingTop'),
      dataVrStructurePaddingBottom: this.get('dataVrStructurePaddingBottom'),
      payload: {
        type: this.get('payload.type')
      }
    };
    var localProp;

    return props.reduce(function(accum, prop){
      localProp = prop.slice(8);

      if ( reg.test( prop ) ) {
        accum[localProp] = self.get(localProp);
      }

      return accum;
    }, base);
  }.property().volatile(),

  newModel: function( element, payload ){
    return PegasusTemplate.CanvasController.createModel(
      {
        id: this.pseudoUuid(),
        recordType: payload.get('type'),
        html: element.innerHTML
      },
      element
    );
  },

  mutateForOut: function(content, cookieOnly){
    function mutate(){
      var payload       = this.get('payload'),
        tag             = payload.get('tagName') || 'div',
        id              = 'id="' + payload.get('elementId') + '"',
        isAligned       = ( tag === 'table' || tag === 'td' ) && payload.$().prop('align'),
        align           = 'align="' + isAligned + '"',
        extraStyles     = 'style="' + payload.extraStyles() + '"',
        dataAttributes  = '',
        html            = content || payload.$() ? payload.$().html() : this.get('sourceElement'),
        data            = PegasusTemplate.Helpers.collectDataAttributes( this.get('element') ),
        /* ignore classes that ember uses */
        filteredClasses = payload.get('classNames').reject(function(name){
          return (/ember/).test( name );
        }).join(' '),
        classes = 'class="' + filteredClasses + '"';

      var keys = Object.keys( data );
      keys.forEach(function(p){
        dataAttributes += [' ', p.dasherize(), '="', data[p].toString().escapeHTML(), '"'].join('');
      });

      function assemble(innerHTML, includeData ) {
        var openingTag = [
            tag,
            includeData ? id : '',
            isAligned ? align : '',
            classes,
            extraStyles,
            includeData ? dataAttributes : ''
          ].join(' ').replace(/^(<)?/, '<').concat('>'),
          closingTag = tag.replace(/^(<\/)?/, '</').concat('>'),
          html = openingTag + innerHTML + closingTag;

        return html;
      }

      if ( cookieOnly ) {
        return {
          editor_cookie: assemble( html, true )
        };
      }

      return {
        message: assemble( html ),
        editor_cookie: assemble( html, true )
      };
    }

    if ( cookieOnly ) {
      return mutate.call(this);
    }

    if ( this.get('isUserVisible') ) {
      return mutate.call(this);
    }

    return this.mutateForOut.call(this, null, true);
  },

  copy: function(){
    var html = this.mutateForOut(null, true).editor_cookie,
      blockView = this.constructor.create({
        sourceElement: html
      });

    blockView.setProperties({
      controller: this.get('controller')
    });

    blockView.mutateForIn( html );
    return blockView;
  },

  pseudoUuid: function(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0;
      var v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
    });
  }
});
